module.exports = __webpack_public_path__ + "static/media/camera-permission.21ee6bfa.png";